import { render, staticRenderFns } from "./batch_close.vue?vue&type=template&id=94ff931c&scoped=true&"
import script from "./batch_close.vue?vue&type=script&lang=js&"
export * from "./batch_close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ff931c",
  null
  
)

export default component.exports